module.exports = __webpack_public_path__ + "static/media/Close.9b06c4f3.svg";